import { createFileRoute } from '@tanstack/react-router'
import { SupplierPaymentDetailPage } from '../../../../features/purchasing/payment-pages'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'

export const Route = createFileRoute('/_app/supplier-payments/$paymentId/')({
  validateSearch: documentActionSearchSchema,
  component: SupplierPaymentDetailPage,
})
